import { graphql } from 'react-relay';

export const gqlUpdateOfferToLikersPercentOff = graphql`
  mutation updateOfferToLikersPercentOffMutation($poshmarkUserLinkId: String!, $percent: Float!) {
    superposherUpdateOfferToLikersPercentOff(poshmarkUserLinkId: $poshmarkUserLinkId, percent: $percent) {
      success
    }
  }
`;
